import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { wishlistStore } from '../utils/wishlist';
/**
 * Botão coração de wishlist. Alterna o produto na lista de desejos do comprador
 * (otimista, via wishlistStore). Só aparece para usuário logado.
 */
export default class WishlistButton extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    if (app.session.user) wishlistStore.ensureLoaded();
  }
  view() {
    if (!app.session.user) return null;
    const id = Number(this.attrs.productId);
    const active = wishlistStore.has(id);
    const label = active ? app.translator.trans('ramon-marketplace.forum.wishlist.remove') : app.translator.trans('ramon-marketplace.forum.wishlist.add');
    return m("button", {
      type: "button",
      className: 'MpBtn MpWishlistBtn ' + (active ? 'is-active ' : '') + (this.attrs.className ?? ''),
      title: label,
      "aria-pressed": active ? 'true' : 'false',
      onclick: () => this.toggle(id)
    }, m("i", {
      className: (active ? 'fas' : 'far') + ' fa-heart'
    }));
  }
  async toggle(id) {
    try {
      const nowIn = await wishlistStore.toggle(id);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ramon-marketplace.forum.wishlist.' + (nowIn ? 'added' : 'removed')));
    } catch {
      // wishlistStore.toggle já reverteu o estado otimista.
    }
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/WishlistButton', WishlistButton);